import React from "react"

import Logo from '../components/Logo.js';
import NavBar from '../components/NavBar.js';
import Footer from '../components/Footer.js';

import styled from 'styled-components';


const Page = styled.div`
position:relative;
min-height:100vh;
overflow-y: scroll;
padding-bottom:300px;
`
const Title = styled.h2`
margin:0 auto;
`


const PageNotFound = () => {

    return (
        <Page>
            <Logo/>
            <NavBar/>
            <Title>Page non trouvée</Title>
            <p>L'URL demandée ne correspond à aucune page</p>
            <Footer/>
        </Page>)
}
export default PageNotFound